// extracted by mini-css-extract-plugin
module.exports = {"container":"ListingAcademySection_container__54LdN","itemsContainer":"ListingAcademySection_itemsContainer__8WY8W"};